import { useEffect, useState } from "react";
import { Tag } from "@NP-Webber/crm-kit/dist/next/index.js";
import { aiCreditsApi, type AiCreditsMeDto } from "../../../api/aiCreditsApi";
import { BLOCKED_TEXT, fmtCredits } from "./creditsUi";

/**
 * The organization's AI balance for the current user (ADR-0035) — shown in the assistant header.
 * Warning tone on low balance, danger when the user is blocked (no credits / limit / not allowed).
 * `refreshKey` reloads it (e.g. after each answer).
 */
export function AiCreditChip({ refreshKey }: { refreshKey?: unknown }) {
  const [me, setMe] = useState<AiCreditsMeDto | null>(null);

  useEffect(() => {
    let alive = true;
    aiCreditsApi
      .me()
      .then((x) => alive && setMe(x))
      .catch(() => alive && setMe(null));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  if (!me) return null;
  const tone = me.blocked ? "danger" : me.lowBalance ? "warning" : "neutral";
  const parts = [
    me.remainingCredits === null ? "יתרת הארגון: ללא הגבלה" : `יתרת הארגון: ${fmtCredits(me.remainingCredits)} קרדיטים`,
    `ניצלת החודש: ${fmtCredits(me.userUsedCredits)}${me.userLimitCredits !== null ? ` מתוך ${fmtCredits(me.userLimitCredits)}` : ""}`,
  ];
  if (me.blocked) parts.unshift(BLOCKED_TEXT[me.blocked]);
  return (
    <Tag tone={tone} icon="coin" title={parts.join("\n")}>
      {me.blocked ? "חסום" : me.remainingCredits === null ? "ללא הגבלה" : fmtCredits(me.remainingCredits)}
    </Tag>
  );
}
